import { MainDashboardPage } from '@/pages/dashboard'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/p/dashboard/main/')({
	component: MainDashboardPage,
})
